module.exports = __webpack_public_path__ + "static/media/translate_spanish.9e0457e0.svg";